import React, { Component } from 'react';

class IconChatRead extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="none"
                viewBox="0 0 16 16"
            >
                <path
                    fill="#13A780"
                    d="M10.234 5.847a.827.827 0 00.209-.767c-.058-.273-.232-.48-.458-.553-.237-.074-.492.006-.677.22l-1.442 1.64L5 9.64c-.012-.013-.023-.033-.04-.053l-.637-.754c-.377-.446-.753-.9-1.13-1.353-.15-.18-.312-.273-.492-.28-.272-.02-.532.167-.642.453a.85.85 0 00.156.874l2.24 2.673c.169.2.342.3.528.3h.005c.18 0 .36-.1.527-.293l3.637-4.134c.364-.406.723-.813 1.082-1.226zM13.876 4.847a.649.649 0 00-.48-.32.685.685 0 00-.557.246l-.764.874c-.868.986-1.737 1.973-2.6 2.96-.214.246-.428.506-.637.76-.08.1-.167.2-.249.306-.011-.013-.023-.026-.029-.04-.046-.06-.086-.106-.127-.153-.156-.167-.342-.233-.538-.193-.273.046-.458.226-.539.513a.835.835 0 00.15.787c.088.1.169.206.255.306.087.1.174.207.255.307.162.2.336.3.521.3h.012c.18 0 .353-.093.521-.28l4.702-5.347a.861.861 0 00.104-1.026z"
                ></path>
            </svg>
        );
    }
}

export default IconChatRead;